const resource = {
    resource_identifier_in_use: 'شناسه API {{indicator}} از قبل در حال استفاده است',
    cannot_delete_management_api: 'نمی‌توان Management API مربوط به Logto را حذف کرد.',
    cannot_modify_management_api: 'نمی‌توان Management API مربوط به Logto را تغییر داد.',
};
export default Object.freeze(resource);
